import { CommonModule } from '@angular/common'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { ModuleWithProviders, NgModule } from '@angular/core'

import { HttpErrorInterceptor } from '@api/common'
import { StylesFilterPipe } from '@api/common/utils'

import { AuthStore, AuthQuery } from './store/auth'

import { HttpService, AuthService, LocalStorageService, FileService, ProfileService, JobAttributeService, WindowRef } from '@api/common/services'
import { ApiCommonModuleOptions } from './api-common.module-options'
import { DragulaService } from 'ng2-dragula'

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  declarations: [
    StylesFilterPipe
  ],
  providers:[
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    FileService,
    LocalStorageService,
    HttpService,
    AuthService,
    ProfileService,
    AuthStore,
    AuthQuery,
    JobAttributeService,
    WindowRef,
    DragulaService
  ],
  exports: [
    StylesFilterPipe
  ]
})
export class ApiCommonModule {
  static forRoot(options: ApiCommonModuleOptions): ModuleWithProviders {

    return {
      ngModule: ApiCommonModule,
      providers: [
        {
          provide: ApiCommonModuleOptions,
          useValue: options
        }
      ]
    }
  }
}
